import { render, staticRenderFns } from "./GetImg.vue?vue&type=template&id=319509e4&scoped=true&"
import script from "./GetImg.vue?vue&type=script&lang=js&"
export * from "./GetImg.vue?vue&type=script&lang=js&"
import style0 from "./GetImg.vue?vue&type=style&index=0&id=319509e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319509e4",
  null
  
)

export default component.exports